import { useEffect, useRef, useState, useCallback } from 'react';
import './App.css';

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// Default center: Papua, Indonesia
const DEFAULT_CENTER = { lat: -3.41, lng: 135.40 };
const DEFAULT_ZOOM = 12;

// Data tanah
const LANDS_DATA = [
  {
    id: 1,
    name: 'Asrama KPG',
    alamat: 'Desa Kalisemen, SP-2, Nabire, Papua Tengah',
    ukuran: '9.658 m²',
    kodeAset: 'KIB-A001',
    color: '#FF0000',
    coords: [
      { lat: -3.440643171419762, lng: 135.44469609152822 },
      { lat: -3.43983421624514, lng: 135.44432743455602 },
      { lat: -3.43957319687734, lng: 135.44487714565499 },
      { lat: -3.43974751143289, lng: 135.44539227147899 },
      { lat: -3.44029740913705, lng: 135.44546521201155 },
      { lat: -3.440643171419762, lng: 135.44469609152822 },
    ],
  },
  {
    id: 2,
    name: 'Tanah Training Center',
    alamat: 'Desa Kalibobo, Nabire, Papua Tengah',
    ukuran: '15.910 m²',
    kodeAset: 'KIB-A002',
    color: '#4CAF50',
    coords: [
      { lat: -3.37989549776294, lng: 135.45675332011623 },
      { lat: -3.38067571080788, lng: 135.45702715224405 },
      { lat: -3.38056790697927, lng: 135.45752742234652 },
      { lat: -3.38047152851014, lng: 135.45807392245194 },
      { lat: -3.38036456210371, lng: 135.45864617295339 },
      { lat: -3.37945178523580, lng: 135.45823361565422 },
      { lat: -3.37989549776294, lng: 135.45675332011623 },
    ],
  },
  {
    id: 3,
    name: 'Sekolah Luar Biasa (SLB)',
    alamat: 'Desa Kalisemen, SP-2, Nabire, Papua Tengah',
    ukuran: '44.739 m²',
    kodeAset: 'KIB-A003',
    color: '#2196F3',
    coords: [
      { lat: -3.42308195858152, lng: 135.44809422857415 },
      { lat: -3.42275714649620, lng: 135.44895561810441 },
      { lat: -3.42247599483324, lng: 135.44962647259828 },
      { lat: -3.42204985175930, lng: 135.45058603355989 },
      { lat: -3.42062235674327, lng: 135.45002258696399 },
      { lat: -3.42089799739081, lng: 135.44921014635906 },
      { lat: -3.42090866445381, lng: 135.44917993408262 },
      { lat: -3.42092003132942, lng: 135.44915045711826 },
      { lat: -3.42092860962497, lng: 135.44912856709973 },
      { lat: -3.42093791702262, lng: 135.44910526622684 },
      { lat: -3.42124771087781, lng: 135.44830977988062 },
      { lat: -3.42199636745240, lng: 135.44861516558998 },
      { lat: -3.42231452490338, lng: 135.44779732319006 },
      { lat: -3.42272999772390, lng: 135.44795489850202 },
      { lat: -3.42277992311122, lng: 135.44797491964690 },
      { lat: -3.42308195858152, lng: 135.44809422857415 },
    ],
  },
  {
    id: 4,
    name: 'Sekolah Anak Papua Tengah',
    alamat: 'Desa Kalisemen, SP-2, Nabire, Papua Tengah',
    ukuran: '43.736 m²',
    kodeAset: 'KIB-A004',
    color: '#FF9800',
    coords: [
      { lat: -3.42089384294236, lng: 135.43947117720600 },
      { lat: -3.42037927837005, lng: 135.44120072867045 },
      { lat: -3.42011230708689, lng: 135.44209806606963 },
      { lat: -3.42168681953581, lng: 135.44249783453458 },
      { lat: -3.42186125251201, lng: 135.44163445826140 },
      { lat: -3.42219597517693, lng: 135.44078251927579 },
      { lat: -3.42142824539235, lng: 135.44051414047269 },
      { lat: -3.42169709408048, lng: 135.43970589782467 },
      { lat: -3.42089384294236, lng: 135.43947117720600 },
    ],
  },
  {
    id: 5,
    name: 'Sekolah Berpola Asrama',
    alamat: 'Desa Karadiri, Nabire, Papua Tengah',
    ukuran: '46.611 m²',
    kodeAset: 'KIB-A005',
    color: '#9C27B0',
    coords: [
      { lat: -3.40791075682753, lng: 135.39059288150068 },
      { lat: -3.40881441137492, lng: 135.39053448461618 },
      { lat: -3.40971715814693, lng: 135.39047309739172 },
      { lat: -3.40963371925062, lng: 135.38961544975788 },
      { lat: -3.40978157292937, lng: 135.38872776020222 },
      { lat: -3.40888183006847, lng: 135.38883615207305 },
      { lat: -3.40890466049961, lng: 135.38793670957307 },
      { lat: -3.40803228917089, lng: 135.38800712868888 },
      { lat: -3.40795865954089, lng: 135.38889141996617 },
      { lat: -3.40793348236668, lng: 135.38978781955669 },
      { lat: -3.40791075682753, lng: 135.39059288150068 },
    ],
  },
  {
    id: 6,
    name: 'Sanggar Kegiatan Belajar',
    alamat: 'desa Karadiri, Nabire, Papua Tengah',
    ukuran: '39.000 m²',
    kodeAset: 'KIB-A006',
    color: '#00BCD4',
    coords: [
      { lat: -3.40496480245233, lng: 135.38992815583475 },
      { lat: -3.40318930815807, lng: 135.39005527966037 },
      { lat: -3.40302230716481, lng: 135.38824404767368 },
      { lat: -3.40490543887545, lng: 135.38809152779478 },
      { lat: -3.40496480245233, lng: 135.38992815583475 },
    ],
  },
  {
    id: 7,
    name: 'Akademi Komunitas',
    alamat: 'desa Karadiri, Nabire, Papua Tengah',
    ukuran: '48.000 m²',
    kodeAset: 'KIB-A007',
    color: '#E91E63',
    coords: [
      { lat: -3.40317275971603, lng: 135.39087897475335 },
      { lat: -3.40312697912143, lng: 135.39007221348413 },
      { lat: -3.40222220209098, lng: 135.39010065166747 },
      { lat: -3.40215955030964, lng: 135.38920312244727 },
      { lat: -3.40204527885315, lng: 135.38830774392602 },
      { lat: -3.40200169070931, lng: 135.38708143337087 },
      { lat: -3.40093765354492, lng: 135.38729756255242 },
      { lat: -3.40103361866189, lng: 135.38831859484986 },
      { lat: -3.40111199285130, lng: 135.38927601772136 },
      { lat: -3.40131643487245, lng: 135.39017606979343 },
      { lat: -3.40136607843801, lng: 135.39103031994784 },
      { lat: -3.40317275971603, lng: 135.39087897475335 },
    ],
  },
  {
    id: 8,
    name: 'Museum & Sanggar Budaya',
    alamat: 'Desa Wanggar Sari, SP-B, Nabire, Papua Tengah',
    ukuran: '40.655 m²',
    kodeAset: 'KIB-A008',
    color: '#795548',
    coords: [
      { lat: -3.42051150413986, lng: 135.35562259203277 },
      { lat: -3.42141064128775, lng: 135.35559297335675 },
      { lat: -3.42241409925520, lng: 135.35554571825014 },
      { lat: -3.42233313852369, lng: 135.35467920143671 },
      { lat: -3.42224535966506, lng: 135.35380642948914 },
      { lat: -3.42133083014943, lng: 135.35385261514961 },
      { lat: -3.42035155320517, lng: 135.35390206898921 },
      { lat: -3.42043056466850, lng: 135.35476422647244 },
      
      
    ],
  },
  {
    id: 9,
    name: 'Kawasan Pusat Pemerintahan Provinsi Papua Tengah',
    alamat: 'Kampung Wanggar Makmur, Distrik Wanggar, Kabupaten Nabire, Provinsi Papua Tengah',
    ukuran: '2.992.013 m²',
    kodeAset: '-',
    color: '#3F51B5',
    coords: [
      { lat: -3.46524996645778, lng: 135.37970998506049 },
      { lat: -3.46520997490642, lng: 135.39371002803765 },
      { lat: -3.48262001778421, lng: 135.39371000206427 },
      { lat: -3.48264995609815, lng: 135.37969000654772 },
      { lat: -3.46524996645778, lng: 135.37970998506049 },
    ],
  },
];

function App() {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const polygonsRef = useRef([]);
  const markersRef = useRef([]);
  const myLocationMarkerRef = useRef(null);
  const myLocationCircleRef = useRef(null);
  const infoWindowRef = useRef(null);
  const [isMapReady, setIsMapReady] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLandId, setSelectedLandId] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Filter lands berdasarkan search
  const filteredLands = LANDS_DATA.filter(land =>
    land.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    land.kodeAset.toLowerCase().includes(searchQuery.toLowerCase()) ||
    land.alamat.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Load Google Maps API
  useEffect(() => {
    if (window.google?.maps?.importLibrary) {
      setIsMapReady(true);
      return;
    }

    const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
    if (existingScript) {
      const checkInterval = setInterval(() => {
        if (window.google?.maps?.importLibrary) {
          setIsMapReady(true);
          clearInterval(checkInterval);
        }
      }, 100);
      return;
    }

    window.initMap = () => {
      setIsMapReady(true);
    };

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=initMap&loading=async`;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      console.error('Failed to load Google Maps API');
    };
    document.head.appendChild(script);
  }, []);

  // Initialize map when API is ready
  useEffect(() => {
    if (!isMapReady || !mapRef.current || mapInstanceRef.current) return;

    const initMap = async () => {
      const { Map } = await window.google.maps.importLibrary('maps');
      const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');

      mapInstanceRef.current = new Map(mapRef.current, {
        center: DEFAULT_CENTER,
        zoom: DEFAULT_ZOOM,
        gestureHandling: 'greedy',
        disableDefaultUI: false,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: window.google.maps.ControlPosition.TOP_RIGHT,
        },
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: window.google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        scaleControl: true,
        mapId: 'gis_map',
      });

      infoWindowRef.current = new window.google.maps.InfoWindow();

      // Draw polygons dan markers untuk setiap tanah
      LANDS_DATA.forEach(land => {
        // Hitung bounds & center dulu
        const bounds = new window.google.maps.LatLngBounds();
        land.coords.forEach(coord => bounds.extend(coord));
        const center = bounds.getCenter();
        const gmapsUrl = `https://www.google.com/maps/search/?api=1&query=${center.lat()},${center.lng()}`;

        const polygon = new window.google.maps.Polygon({
          paths: land.coords,
          strokeColor: land.color,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: land.color,
          fillOpacity: 0.35,
        });
        polygon.setMap(mapInstanceRef.current);
        polygon.landId = land.id;

        const infoContent =
          `<div style="padding:6px;font-family:Roboto,Arial,sans-serif;min-width:200px">
            <strong style="font-size:14px">${land.name}</strong>
            <div style="margin-top:6px;font-size:12px;color:#555;line-height:1.6">
              <div><b>Alamat:</b> ${land.alamat}</div>
              <div><b>Ukuran:</b> ${land.ukuran}</div>
              <div><b>Kode Aset:</b> ${land.kodeAset}</div>
            </div>
            <a href="${gmapsUrl}" target="_blank" rel="noopener noreferrer"
              style="display:inline-block;margin-top:8px;font-size:12px;color:#1a73e8;text-decoration:none">
              View on Google Maps
            </a>
          </div>`;

        // Klik polygon untuk info
        polygon.addListener('click', (event) => {
          infoWindowRef.current.setContent(infoContent);
          infoWindowRef.current.setPosition(event.latLng);
          infoWindowRef.current.open(mapInstanceRef.current);
          setSelectedLandId(land.id);
        });

        polygonsRef.current.push(polygon);

        // Marker di center polygon
        const markerContent = document.createElement('div');
        markerContent.className = 'land-marker';
        markerContent.textContent = land.name;

        const marker = new AdvancedMarkerElement({
          map: mapInstanceRef.current,
          position: center,
          content: markerContent,
          title: land.name,
        });

        marker.addListener('click', () => {
          infoWindowRef.current.setContent(infoContent);
          infoWindowRef.current.setPosition(center);
          infoWindowRef.current.open(mapInstanceRef.current);
          setSelectedLandId(land.id);
        });

        markersRef.current.push(marker);
      });

      // Tombol My Location
      const locationBtn = document.createElement('button');
      locationBtn.className = 'my-location-btn';
      locationBtn.title = 'Lokasi Saya';
      locationBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/></svg>`;
      locationBtn.addEventListener('click', () => {
        if (navigator.geolocation) {
          locationBtn.classList.add('loading');
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              const accuracy = position.coords.accuracy;

              // Blue dot marker
              if (myLocationMarkerRef.current) {
                myLocationMarkerRef.current.setMap(null);
              }
              if (myLocationCircleRef.current) {
                myLocationCircleRef.current.setMap(null);
              }

              // Blue accuracy circle
              myLocationCircleRef.current = new window.google.maps.Circle({
                center: pos,
                radius: accuracy,
                strokeColor: '#4285F4',
                strokeOpacity: 0.3,
                strokeWeight: 1,
                fillColor: '#4285F4',
                fillOpacity: 0.1,
                map: mapInstanceRef.current,
                clickable: false,
              });

              // Blue dot
              myLocationMarkerRef.current = new window.google.maps.Marker({
                position: pos,
                map: mapInstanceRef.current,
                icon: {
                  path: window.google.maps.SymbolPath.CIRCLE,
                  scale: 8,
                  fillColor: '#4285F4',
                  fillOpacity: 1,
                  strokeColor: '#fff',
                  strokeWeight: 2.5,
                },
                title: 'Lokasi Saya',
                zIndex: 999,
              });

              mapInstanceRef.current.panTo(pos);
              mapInstanceRef.current.setZoom(15);
              locationBtn.classList.remove('loading');
            },
            () => {
              locationBtn.classList.remove('loading');
              alert('Gagal mendapatkan lokasi. Pastikan GPS aktif.');
            }
          );
        } else {
          alert('Browser tidak mendukung Geolocation.');
        }
      });
      mapInstanceRef.current.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(locationBtn);
    };

    initMap();
  }, [isMapReady]);

  // Klik tanah di sidebar → zoom ke polygon
  const handleLandClick = useCallback((land) => {
    if (!mapInstanceRef.current) return;
    setSelectedLandId(land.id);
    const bounds = new window.google.maps.LatLngBounds();
    land.coords.forEach(coord => bounds.extend(coord));
    mapInstanceRef.current.fitBounds(bounds);

    if (infoWindowRef.current) {
      const centerPos = bounds.getCenter();
      const gmapsUrl = `https://www.google.com/maps/search/?api=1&query=${centerPos.lat()},${centerPos.lng()}`;
      infoWindowRef.current.setContent(
        `<div style="padding:6px;font-family:Roboto,Arial,sans-serif;min-width:200px">
          <strong style="font-size:14px">${land.name}</strong>
          <div style="margin-top:6px;font-size:12px;color:#555;line-height:1.6">
            <div><b>Alamat:</b> ${land.alamat}</div>
            <div><b>Ukuran:</b> ${land.ukuran}</div>
            <div><b>Kode Aset:</b> ${land.kodeAset}</div>
          </div>
          <a href="${gmapsUrl}" target="_blank" rel="noopener noreferrer"
            style="display:inline-block;margin-top:8px;font-size:12px;color:#1a73e8;text-decoration:none">
            View on Google Maps
          </a>
        </div>`
      );
      infoWindowRef.current.setPosition(bounds.getCenter());
      infoWindowRef.current.open(mapInstanceRef.current);
    }

    // Auto minimize sidebar di mobile
    if (window.innerWidth <= 768) {
      setSidebarOpen(false);
    }
  }, []);

  return (
    <div className="app-container">
      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2>GIS Maps</h2>
          <button className="sidebar-toggle" onClick={() => setSidebarOpen(false)}>
            ✕
          </button>
        </div>

        <div className="sidebar-search">
          <input
            type="text"
            placeholder="Cari tanah..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="sidebar-list">
          {filteredLands.length === 0 && (
            <div className="sidebar-empty">Tidak ada data ditemukan</div>
          )}
          {filteredLands.map(land => (
            <div
              key={land.id}
              className={`land-item ${selectedLandId === land.id ? 'selected' : ''}`}
              onClick={() => handleLandClick(land)}
            >
              <div className="land-color" style={{ backgroundColor: land.color }} />
              <div className="land-info">
                <div className="land-name">{land.name}</div>
                <div className="land-desc">{land.kodeAset}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Tombol buka sidebar */}
      {!sidebarOpen && (
        <button className="sidebar-open-btn" onClick={() => setSidebarOpen(true)}>
          ☰
        </button>
      )}

      {/* Map */}
      {!isMapReady && <div className="loading">Loading Google Maps...</div>}
      <div ref={mapRef} className="map" />
    </div>
  );
}

export default App;
